import React, { FC } from 'react';

import { Table } from '@column/column-ui-kit';

import { formatCounterpartyLabel, useCounterpartyOptions } from '~/components/fields/CounterpartyDropdown';
import { useDebounce } from '~/hooks';

interface CounterpartyCellProps {
  isEditable?: boolean;
  value?: string;
  onChange?: ({ description, id }: { description: string; id: string }) => void;
}

export const CounterpartyCell: FC<CounterpartyCellProps> = ({ isEditable, value, onChange }) => {
  const { options, hiddenOptions, search, counterparties } = useCounterpartyOptions({ value });

  const [handleSearch] = useDebounce(
    (searchVal?: string) => {
      search(searchVal);
    },
    500,
    [search]
  );

  return (
    <Table.OptionCell
      isEditable={isEditable}
      value={value}
      options={options}
      hiddenOptions={hiddenOptions}
      fullWidth
      search
      searchLabel="Search..."
      onSearchChange={handleSearch}
      emptyMessage="No counterparties found"
      onChange={(newValue: string) => {
        const cp = counterparties.find((c) => c.id === newValue);
        onChange?.({
          description: cp ? formatCounterpartyLabel(cp) : '',
          id: newValue,
        });
      }}
    />
  );
};
